import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledThumbsUp = styled.svg<IconProps>`
  & .cls-1,
  .cls-2 {
    fill: none;
  }

  & .cls-3 {
    fill: var(--chatbot-color-primary, #404040);
  }

  & .cls-4,
  .cls-5 {
    stroke: none;
  }

  & .cls-5 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.hover:hover,
  &.active {
    .cls-1 {
      fill: none;
    }

    .cls-2,
    .cls-3 {
      fill: var(--du-color-primary, #128370);
    }

    .cls-4,
    .cls-5 {
      stroke: none;
    }

    .cls-5 {
      fill: var(--du-color-primary, #128370);
    }
  }
`;

const ThumbsUpIcon: React.FC<IconProps> = ({ active }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledThumbsUp
      id='Thumbs-Up-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <rect id='Margin' className='cls-1' width='32' height='32' />
      <g id='Group_17469' data-name='Group 17469' transform='translate(2.294 3.206)'>
        <g id='Path_15937' data-name='Path 15937' className='cls-2' transform='translate(-1.844)'>
          <path
            className='cls-4'
            d='M11.25,21.089H20.1a1.547,1.547,0,0,0,1.44-1.011l2.405-5.849a1.691,1.691,0,0,0,.11-.6V11.956a1.891,1.891,0,0,0-1.592-1.927H17.437L18.2,6.509l.025-.259a1.269,1.269,0,0,0-.35-.877L17.02,4.5c.037.035-5.77,6.935-5.77,6.935Z'
          />
          <path
            className='cls-5'
            d='M 20.0950813293457 20.08885765075684 C 20.4298210144043 20.08885765075684 20.5705509185791 19.79892730712891 20.6057014465332 19.7100772857666 L 20.6107006072998 19.69769668579102 L 23.00885009765625 13.86511039733887 C 23.03696632385254 13.78684997558594 23.05010032653809 13.70986175537109 23.05010032653809 13.62386703491211 L 23.05010032653809 11.95634651184082 C 23.05010032653809 11.49672698974609 22.67023086547852 11.02961730957031 22.4579906463623 11.02961730957031 L 16.19910049438477 11.02961730957031 L 17.20578956604004 6.354545593261719 L 17.21907043457031 6.218368053436279 C 17.21037483215332 6.139400005340576 17.17050361633301 6.087460994720459 17.15037536621094 6.065828800201416 L 17.09334945678711 6.007338047027588 C 17.03401756286621 6.07927942276001 16.97110176086426 6.155439853668213 16.90466117858887 6.23574686050415 C 16.42638206481934 6.813847064971924 15.75724124908447 7.616827011108398 14.91582107543945 8.622386932373047 C 13.82463455200195 9.926422119140625 12.71998310089111 11.24090003967285 12.25000095367432 11.79983139038086 L 12.25000095367432 20.08885765075684 L 20.0950813293457 20.08885765075684 M 20.0950813293457 21.08885765075684 L 11.25000095367432 21.08885765075684 L 11.25000095367432 11.43519687652588 C 11.25000095367432 11.43519687652588 17.05693054199219 4.534786701202393 17.02036094665527 4.499997138977051 L 17.87117195129395 5.372646808624268 C 18.08598136901855 5.597286701202393 18.22077178955078 5.908327102661133 18.22077178955078 6.249607086181641 L 18.19549179077148 6.508806705474854 L 17.43735122680664 10.02961730957031 L 22.4579906463623 10.02961730957031 C 23.33407020568848 10.02961730957031 24.05010032653809 11.0448169708252 24.05010032653809 11.95634651184082 L 24.05010032653809 13.62386703491211 C 24.05010032653809 13.83986663818359 24.01219177246094 14.03858661651611 23.94059181213379 14.22866725921631 L 21.53557205200195 20.07796669006348 C 21.29970169067383 20.67413711547852 20.75636100769043 21.08885765075684 20.0950813293457 21.08885765075684 Z'
          />
        </g>
        <path
          id='Path_15938'
          data-name='Path 15938'
          className='cls-3'
          d='M3.375,15.75h3.2v9.677h-3.2Z'
          transform='translate(1.831 -4.338)'
        />
      </g>
    </StyledThumbsUp>
  );
};

export default ThumbsUpIcon;
